import { render, staticRenderFns } from "./pdc_out_former.vue?vue&type=template&id=2a8f3f3d&scoped=true&"
import script from "./pdc_out_former.vue?vue&type=script&lang=js&"
export * from "./pdc_out_former.vue?vue&type=script&lang=js&"
import style0 from "./pdc_out_former.vue?vue&type=style&index=0&id=2a8f3f3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f3f3d",
  null
  
)

export default component.exports